export default __webpack_public_path__ + "static/media/NL.a7fdb74e.svg";